var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cafaee",
    d: "M18.667 19.378c-0.178 0-0.356-0.089-0.444-0.178l-2.667-2.667c-0.089-0.089-0.178-0.267-0.178-0.444v-4.267c0-0.356 0.267-0.711 0.711-0.711s0.711 0.267 0.711 0.711v4l2.489 2.489c0.267 0.267 0.267 0.711 0 0.978-0.267 0-0.444 0.089-0.622 0.089z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cafaee",
    d: "M16 27.378c-6.222 0-11.378-5.156-11.378-11.378 0-1.956 0.533-3.911 1.511-5.689 0.178-0.356 0.622-0.444 0.889-0.267 0.356 0.178 0.444 0.622 0.267 0.889-0.889 1.511-1.333 3.2-1.333 4.978 0 5.511 4.444 9.956 9.956 9.956s9.956-4.444 9.956-9.956-4.356-9.867-9.867-9.867c-1.778 0-3.467 0.444-4.978 1.333-0.356 0.178-0.711 0.089-0.889-0.267s-0.089-0.711 0.267-0.889c1.689-0.978 3.644-1.511 5.689-1.511 6.222 0 11.378 5.067 11.378 11.378s-5.244 11.289-11.467 11.289z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.1335dd65fdf2b975819fb8ae983b1610.svg";
export { ForwardRef as ReactComponent };